import { BaseCanvas } from "@visactor/vrender-core";

import { NodeContext2d } from "./context";

import { isFunction } from "@visactor/vutils";

export class NodeCanvas extends BaseCanvas {
    constructor(params) {
        super(params);
    }
    init() {
        this._context = new NodeContext2d(this, this._dpr), this.nativeCanvas.width = this._pixelWidth, 
        this.nativeCanvas.height = this._pixelHeight;
    }
    release(...params) {
        this._nativeCanvas.release && isFunction(this._nativeCanvas.release) && this._nativeCanvas.release();
    }
}

NodeCanvas.env = "node";
//# sourceMappingURL=canvas.js.map
